import {useState} from "react";
import {useDebouncedState} from "@mantine/hooks";
import DefaultTable from "../../components/DefaultTable";
import {IWhereKnown} from "../../api/types";
import {useGetWhereKnownQuery} from "../../api/whereKnown";
import PageContainer from "../../components/PageContainer";

const WhereKnown = () => {
    const [page, setPage] = useState(1)
    const [search, setSearch] = useDebouncedState('', 200);
    const {data = {content: [], totalPages: 0}, isFetching} = useGetWhereKnownQuery({page, pageSize: 10, search})

    function onRowClick(record: IWhereKnown) {

    }

    return (
        <PageContainer>
            <DefaultTable
                data={data}
                columns={[{name: 'name', label: 'Наименование'}]}
                onChangePage={setPage}
                isFetching={isFetching}
                page={page}
                onSearch={setSearch}
                enableSearch={true}
                searchPlaceholder={'Поиск по всем полям'}
                onRowClick={onRowClick}
            />
        </PageContainer>
    )
}

export default WhereKnown;